module.exports = __webpack_public_path__ + "static/img/3-6.4.5.11d3a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/5/3-6.4.5.png
// module id = w+Ft
// module chunks = 0